import axios from "axios";
import { BASE_API_URL } from "../consts";
import type { MealSupplierLink } from "./suppliersAPI";

export type MealType = "breakfast" | "lunch" | "dinner" | "snack" | "other";

export const MEAL_TYPE_LABEL: Record<MealType, string> = {
  breakfast: "Doručak",
  lunch: "Ručak",
  dinner: "Večera",
  snack: "Užina",
  other: "Ostalo",
};

export const MEAL_TYPE_ICON: Record<MealType, string> = {
  breakfast: "🍳",
  lunch: "🥗",
  dinner: "🍽️",
  snack: "🥪",
  other: "🍴",
};

export interface MealItem {
  _id?: string;
  name: string;
  description?: string | null;
  price: number;
  isAvailable: boolean;
}

export interface ClientMeal {
  _id: string;
  clientId: string;
  name: string;
  type: MealType;
  description?: string | null;
  items: MealItem[];
  extras?: MealItem[];
  suppliers?: MealSupplierLink[];
  orderingRules?: string[];
  currency: "EUR" | "RSD" | "BAM";
  isActive: boolean;
  archived?: boolean;
  createdAt: string;
  updatedAt: string;
}

// Per-day meal selection (what the guest chose)
export interface MealSelection {
  date: string;         // YYYY-MM-DD
  mealId: string;
  mealName: string;     // snapshot
  itemId: string;
  itemName: string;     // snapshot
  persons: number;      // how many people ordered this
  price: number;        // total for this entry (item.price × persons, 0 if included)
  isIncluded: boolean;
}

// How a meal is configured on an apartment
export interface ApartmentMealSetting {
  mealId: ClientMeal | string;   // populated or just ID
  includedInPrice: boolean;
  pricePerPerson?: number;       // if set → flat per-person mode (no item selection)
}

// ─── API calls ────────────────────────────────────────────────────────────────

export const getMeals = (clientId: string) =>
  axios.get<ClientMeal[]>(`${BASE_API_URL}/${clientId}/apt-meals`);

export const createMeal = (clientId: string, data: Partial<ClientMeal>) =>
  axios.post<ClientMeal>(`${BASE_API_URL}/${clientId}/apt-meals`, data);

export const updateMeal = (id: string, data: Partial<ClientMeal>) =>
  axios.put<ClientMeal>(`${BASE_API_URL}/apt-meals/${id}`, data);

export const deleteMeal = (id: string) =>
  axios.delete(`${BASE_API_URL}/apt-meals/${id}`);
